import { Gradient } from '@appcharge/shared-ui';
import { EFontWeight } from 'constants/enums';

export enum EFacebookButtonVariant {
  DEFAULT = 'default',
  OUTLINED = 'outlined'
}

export interface LoginThemeFormValues {
  errorMessage: {
    title: string;
    subTitle: string;
  };
  text: string;
  textColor: string;
  textSize: number;
  textWeight: EFontWeight;
  font: string;
  loginLogoImage?: string;
  loginLogoSize: string;
  loginBackgroundImageMobile?: string;
  loginBackgroundImageDesktop?: string;
  otpButton: {
    icon: string;
    text: string;
    backgroundColor: Gradient;
    textColor: Gradient;
  };
  facebookButton: {
    variant: EFacebookButtonVariant;
  };
  consentSection: {
    htmlText?: string;
    consentRequired?: boolean;
  };
  accountApprovalModal: {
    backgroundImage: string;
    backgroundColor: Gradient;
    borderColor: string;
    borderWidth: number;
    buttonTextColor: string;
    buttonBackgroundColor: Gradient;
    textColor: string;
    additionalText?: string;
  };
}
